import type { ICellRendererComp, ICellRendererParams } from "@ag-grid-community/core";

export class MasterDetailCellRenderer implements ICellRendererComp {
  detailCellGui!: HTMLElement;

  init(params: ICellRendererParams) {
    this.detailCellGui = document.createElement("div");
    this.detailCellGui.setAttribute("role", "gridcell");
    this.detailCellGui.setAttribute("class", "h-full w-full");

    this.detailCellGui.setAttribute(
      "style",
      // ENG-21465 flex-centre the summary vertically within the fixed-height detail row
      `padding-left: 44px; background-color: #f5f5f5; overflow: auto; text-wrap: break-word; white-space: normal; display: flex; align-items: center;`,
    );

    this.detailCellGui.innerHTML = this.buildSummaryHtml(params);
  }

  getGui() {
    return this.detailCellGui;
  }

  refresh(params: ICellRendererParams) {
    this.detailCellGui.innerHTML = this.buildSummaryHtml(params);

    return true;
  }

  buildSummaryHtml(params: ICellRendererParams) {
    const summary = this.getSummary(params);
    // ENG-21465 margin:0 removes the default <p> margin that pushed the text off-centre
    return `<p style="margin: 0;"><strong>${params.data.summaryLabel}</strong>: ${summary}</p>`;
  }

  getSummary(params) {
    const numberOfSummaryCharacters = Math.floor(params.columnApi.columnModel.scrollWidth / 4);
    let summary = params.data.summary;

    if (!!summary && summary.length > numberOfSummaryCharacters) {
      summary = summary.substring(0, numberOfSummaryCharacters) + "...";
    }
    return summary;
  }
}
